<div class="pa-message-content pa-message-content-text">
    <div class="pa-typing-indicator"></div>
</div>
